<template>
  <div class="page-XLproductPresentation container-fluid" ref="box">
    <div class="box-padding">
      <div
        class="XLproductPresentation-text animate__animated animate__slow"
        ref="title"
      >
        <h1 class="title">产品介绍</h1>
        <p class="title-en title">Product Presentation</p>
        <img class="mt-4" src="../style/img/picture.png" alt="" />
      </div>
      <div
        class="XLproductPresentation-content animate__animated animate__slow"
        ref="XLproductPresentation-content"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="title">W-HUD</div>
          </div>
          <div class="col-md-4 mt-5">
            <div class="content">
              <h3 class="col-md-12 content-title">技术方案</h3>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">PGU</div>
                <div class="col-md-6 content-value">3.1inch TFT</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">FOV</div>
                <div class="col-md-6 content-value">7° * 3°</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">VID</div>
                <div class="col-md-6 content-value">2.8M</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">体积</div>
                <div class="col-md-6 content-value">7L</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">亮度</div>
                <div class="col-md-6 content-value">>10000nits</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">清晰度</div>
                <div class="col-md-6 content-value">800 * 480 (pixel)</div>
              </div>
            </div>
            <button
              type="button"
              @click="handleClick('/Arhud')"
              class="btn btn-primary mt-4 mb-4"
            >
              了解更多
            </button>
          </div>
          <div class="col-md-6 offset-md-2">
            <img
              width="100%"
              height="100%"
              src="../style/img/picture3.png"
              alt=""
            />
          </div>
        </div>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-12 text-right">
            <div class="title d-inline-block">AR-HUD 1.0</div>
          </div>
          <div class="col-md-6 max-top">
            <img
              width="100%"
              height="100%"
              src="../style/img/picture4.png"
              alt=""
            />
          </div>
          <div class="col-md-4 text-right offset-md-2 mt-5">
            <div class="content text-left">
              <h3 class="col-md-12 content-title">技术方案</h3>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">PGU</div>
                <div class="col-md-6 content-value">DLP 3030</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">FOV</div>
                <div class="col-md-6 content-value">9° * 3°</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">VID</div>
                <div class="col-md-6 content-value">7.5M</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">体积</div>
                <div class="col-md-6 content-value">10L</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">亮度</div>
                <div class="col-md-6 content-value">>12000nits</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">清晰度</div>
                <div class="col-md-6 content-value">856 * 480 (pixel)</div>
              </div>
            </div>
            <button
              type="button"
              @click="handleClick('/Arhud')"
              class="btn btn-primary mt-4"
            >
              了解更多
            </button>
          </div>
        </div>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-12">
            <div class="title">AR-HUD 2.0</div>
          </div>
          <div class="col-md-4 mt-5">
            <div class="content">
              <h3 class="col-md-12 content-title">技术方案</h3>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">PGU</div>
                <div class="col-md-6 content-value">DLP 4620</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">FOV</div>
                <div class="col-md-6 content-value">12° * 5°</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">VID</div>
                <div class="col-md-6 content-value">10M</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">体积</div>
                <div class="col-md-6 content-value">14L</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">亮度</div>
                <div class="col-md-6 content-value">>12000nits</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">清晰度</div>
                <div class="col-md-6 content-value">1358 * 566 (pixel)</div>
              </div>
            </div>
            <button
              type="button"
              @click="handleClick('/Arhud')"
              class="btn btn-primary mt-4 mb-4"
            >
              了解更多
            </button>
          </div>
          <div class="col-md-6 offset-md-2">
            <img
              width="100%"
              height="100%"
              src="../style/img/picture5.png"
              alt=""
            />
          </div>
        </div>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-12 text-right">
            <div class="title d-inline-block">斜投影AR-HUD</div>
          </div>
          <div class="col-md-6 max-top">
            <img
              width="100%"
              height="100%"
              src="../style/img/picture7.png"
              alt=""
            />
          </div>
          <div class="col-md-4 offset-md-2 mt-5 text-right">
            <div class="content text-left">
              <h3 class="col-md-12 content-title">技术方案</h3>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">PGU</div>
                <div class="col-md-6 content-value">TFT/DLP</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">FOV</div>
                <div class="col-md-6 content-value">11° * 4°</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">VID</div>
                <div class="col-md-6 content-value">4M~11M</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">体积</div>
                <div class="col-md-6 content-value">13L</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">亮度</div>
                <div class="col-md-6 content-value">>12500nits</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">清晰度</div>
                <div class="col-md-6 content-value">1280 * 640 (pixel)</div>
              </div>
            </div>
            <button
              type="button"
              @click="handleClick('/Arhud')"
              class="btn btn-primary mt-4"
            >
              了解更多
            </button>
          </div>
        </div>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-12">
            <div class="title">车载冰箱</div>
          </div>
          <div class="col-md-4 mt-5">
            <div class="content">
              <h3 class="col-md-12 content-title">技术方案</h3>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">实际体积</div>
                <div class="col-md-6 content-value">5L~20L</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">有效体积比</div>
                <div class="col-md-6 content-value">20%~30%</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">噪声</div>
                <div class="col-md-6 content-value">≤33DB（A）</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">产品储存温度</div>
                <div class="col-md-6 content-value">-40°C~90°C</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">工作环境温度</div>
                <div class="col-md-6 content-value">-10°C ~55°C</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">制冷设计温度</div>
                <div class="col-md-6 content-value">-6°C ~10°C</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">空载制冷速度</div>
                <div class="col-md-6 content-value">
                  环温32°C，制冷至0°C ≤30min
                </div>
              </div>
            </div>
            <button
              type="button"
              @click="handleClick('/CoolingCabinet')"
              class="btn btn-primary mt-4 mb-4"
            >
              了解更多
            </button>
          </div>
          <div class="col-md-6 offset-md-2">
            <img
              width="100%"
              height="100%"
              src="../style/img/picture10.png"
              alt=""
            />
          </div>
        </div>
        <!-- <div class="row" style="margin-top: 100px">
          <div class="col-md-12 text-right">
            <div class="title d-inline-block">车载冰箱-后装</div>
          </div>
          <div class="col-md-6 mt-5">
            <img
              width="100%"
              height="100%"
              src="../style/img/picture10.png"
              alt=""
            />
          </div>
          <div class="col-md-4 offset-md-2 mt-5 text-right">
            <div class="content text-left">
              <h3 class="col-md-12 content-title">浦创智能技术方案</h3>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">实际体积（L）</div>
                <div class="col-md-6 content-value">＞22</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">有效体积比</div>
                <div class="col-md-6 content-value">38.4%</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">噪声</div>
                <div class="col-md-6 content-value">≤39DB（A）</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">产品储存温度（℃）</div>
                <div class="col-md-6 content-value">-40～90</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">工作环境温度（℃）</div>
                <div class="col-md-6 content-value">>-10～60</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">制冷设计温度（℃）</div>
                <div class="col-md-6 content-value">-20～10</div>
              </div>
              <div class="col-md-12 d-flex p-0">
                <div class="col-md-6 content-label">空载制冷速度</div>
                <div class="col-md-6 content-value">25℃降温至0℃≤11min</div>
              </div>
            </div>
            <button
              type="button"
              @click="handleClick('/CoolingCabinet')"
              class="btn btn-primary mt-4"
            >
              了解更多
            </button>
          </div>
        </div> -->
        <div class="row" style="margin-top: 100px">
          <div class="col-md-12">
            <div class="title">其他智能座舱产品</div>
          </div>
          <div class="col-md-12 mt-5">
            <div class="content d-flex flex-wrap">
              <div
                class="col-md-3 col-6 d-flex flex-wrap justify-content-center"
              >
                <img src="../style/img/picture11.png" alt="" />
                <span class="peripheralProductstext">AR 眼镜</span>
              </div>
              <div
                class="col-md-3 col-6 d-flex flex-wrap justify-content-center"
              >
                <img src="../style/img/picture12.png" alt="" />
                <span class="peripheralProductstext">车内投影</span>
              </div>
              <div
                class="col-md-3 col-6 d-flex flex-wrap justify-content-center"
              >
                <img src="../style/img/picture13.png" alt="" />
                <span class="peripheralProductstext">CMS</span>
              </div>
              <div
                class="col-md-3 col-6 d-flex flex-wrap justify-content-center"
              >
                <img src="../style/img/picture14.png" alt="" />
                <span class="peripheralProductstext">域控制器</span>
              </div>
              <!-- <div
                class="col-md-2 col-12 d-flex flex-wrap justify-content-center"
              >
                <span style="font-size: 6rem; color: #fff">...</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XLproductPresentation",

  data() {
    return {
      oldScrollTop: 0,
    };
  },
  methods: {
    handleClick(url) {
      this.$router.replace(url);
    },
    handleScroll() {
      let _this = this;
      let refArray = [
        {
          ref: "title",
          height: 0,
          animate: "animate__slideInUp",
        },
        {
          ref: "XLproductPresentation-content",
          height: 0,
          animate: "animate__slideInUp",
        },
      ];
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;
      if (scrollStep < 0) {
        refArray.forEach((r) => {
          var a, c, d;
          a = this.$refs["box"].offsetTop;
          c = scrollTop; //  获取窗口滚动条高度
          d =
            document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
          if (c + d < a) {
            this.$refs[r.ref].classList.remove(r.animate);
          }
        });
      } else {
        refArray.forEach((r) => {
          _this.$utils.gdjz(this.$refs[r.ref], r.height, r.animate, () => {
            window.requestAnimationFrame(function () {
              _this.$refs[r.ref].classList.add(r.animate);
            });
          });
        });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.page-XLproductPresentation {
  // padding: 50px;
  margin-top: 8rem;
  // background-image: url(../style/img/picture6.png);
  // background-repeat: no-repeat;
  // background-size: cover;
  .box-padding {
    padding: 0 13%;
  }
  @media (max-width: 960px) {
    .box-padding {
      padding: 20px;
    }
  }
 @media (max-width: 960px) {
    .max-top {
      margin-top: 3rem;
    }
  }
  .XLproductPresentation-text {
    text-align: center;
    .title {
      color: #fff;
      font-size: 2rem;
    }
    .title-en {
      font-size: 1.2rem;
      color: #ffffff6e;
    }

    @media (max-width: 960px) {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .XLproductPresentation-content {
    margin-top: 3rem;
    .title {
      color: #fff;
      line-height: 46px;
      text-align: center;
      width: 18%;
      background-image: url(../style/img/picture2.png);
      background-position: center center;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: cover;
      border-radius: 20px;
      font-size: 1.4rem;
    }
    @media (max-width: 960px) {
      .title {
        width: 100%;
      }
    }
    .content {
      .content-title {
        font-size: 1.4rem;
        color: #ffffff;
        line-height: 2rem;
        background-color: #1f73be;
        text-align: center;
      }
      .content-label {
        font-size: 1rem;
        color: #ffffff;
        line-height: 1.6rem;
        background-color: #535353ab;
        margin: 2px 0;
      }
      .content-value {
        font-size: 1rem;
        color: #ffffff;
        margin: 2px 0;
        white-space: nowrap;
      }
      .peripheralProductstext {
        width: 60%;
        color: #fff;
        font-size: 1.2rem;
        text-align: center;
      }
    }
    button {
      height: 45px;
      width: 130px;
      border-radius: 20px;
      background-color: #fff0;
      background-image: url(../style/img/picture8.png);
      background-position: center center;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: cover;
      border: none;
    }
    button:hover {
      background-image: url(../style/img/picture2.png);
    }
    button:active {
      background-color: #fff0;
      border: none;
    }
    button:active:focus {
      box-shadow: 0px 0px 0 0.2rem #0fb5d2;
    }
    button:focus {
      box-shadow: none;
    }
    img {
      // object-fit: none;
      object-fit: contain;
      cursor: pointer;
      transition: all 0.6s;
    }
    img:hover {
      transform: scale(1.1);
    }
  }
}
</style>
